import { Component, ElementRef, Input, Output, EventEmitter, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TagStruct } from './tag.struct';
import { Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagComponent implements OnInit {

  @Input() listTags: TagStruct[];
  @Input() allTags: TagStruct[];
  @Input() isFlow: boolean = false;
  @Output() tagsChange = new EventEmitter<TagStruct[]>(); 

  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;

  public tagCtrl = new UntypedFormControl();
  public filteredTags: Observable<TagStruct[]>;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  constructor() {}

  ngOnInit(): void {
    if (!this.listTags) this.listTags = [];

    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) => {
        const candidates = (tag && typeof tag === 'string')
          ? this._filter(tag)
          : this.allTags.slice();

        return candidates.filter(c =>
          !this.listTags.some(selected => selected.idTag === c.idTag)
        );
      }),
    );
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      const existingIndex = this.allTags.findIndex(t => t.tagName.toLowerCase() === value.toLowerCase());

      if (existingIndex >= 0) {
        const tag = this.allTags[existingIndex];
        const jaExiste = this.listTags.some(t => t.idTag === tag.idTag);
        
        if (!jaExiste) {
          this.listTags.push(tag);
        }
      } else if (this.isFlow) {
        this.listTags.push({ idTag: null, tagName: value, priority: null, colorCode: null, isDeleted: null });
      }
    }

    if (event.input) {
      event.input.value = '';
    } else if (event.chipInput) {
      event.chipInput.clear(); 
    }
    
    this.tagCtrl.setValue(null);
    this.tagsChange.emit(this.listTags);
  }

  remove(tag: TagStruct): void {
    const index = this.listTags.indexOf(tag);

    if (index >= 0) {
      this.listTags.splice(index, 1);

      if (this.tagInput && this.tagInput.nativeElement) {
        this.tagInput.nativeElement.value = '';
      }
      this.tagCtrl.setValue(null);
      this.tagsChange.emit(this.listTags);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const newTag: TagStruct = event.option.value;
    const jaExiste = this.listTags.some(t => t.idTag === newTag.idTag);

    if (!jaExiste) {
      this.listTags.push(newTag);
    }

    if (this.tagInput && this.tagInput.nativeElement) {
      this.tagInput.nativeElement.value = '';
    }
    
    this.tagCtrl.setValue(null);
    this.tagsChange.emit(this.listTags);
  }

  private _filter(value: string): TagStruct[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(l => l.tagName.toLowerCase().includes(filterValue));
  }
}